export default {"src":"/_next/static/media/aed.fbc4fdb5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};